// extracted by mini-css-extract-plugin
module.exports = {"mr9":"style_mr9__3MAJD","fontSize16":"style_fontSize16__2RDou"};